module.exports = __webpack_public_path__ + "static/media/welcome_image_1.391d2771.png";